import React from "react";
import { FontIcon } from "@companion-core/shared/app/Components/FontIcon";
import "@companion-core/web/src/Assets/Styles/scss/InputClearButton.scss";
import { useTranslation } from "react-i18next";

interface Props {
  name?: string;
  ariaLabel?: string;
  testID?: string;
  isInputSelect?: boolean;
  clearInput?: () => void;
}

const InputClearButton = ({ name, ariaLabel, testID, isInputSelect, clearInput }: Props) => {
  const { t } = useTranslation();
  const onKeyDown = isInputSelect
    ? (e: React.KeyboardEvent<HTMLButtonElement>) => {
        if (e.key === "Enter") {
          clearInput?.();
        }
      }
    : undefined;
  return (
    <button
      type="button"
      className="JPInputElements__clear-button"
      aria-label={ariaLabel ?? t("common.form.input.actions.clear")}
      onMouseDown={(e) => e.preventDefault()}
      onKeyDown={onKeyDown}
      onClick={clearInput}>
      <FontIcon
        name={name ?? "JP-Circle-close-outline"}
        size={24}
        data-testid={`${testID}--clear`}
        aria-hidden="true"
      />
    </button>
  );
};

export default InputClearButton;
